import { actionCreator } from '@ardoq/rxbeach';

export const activateReferenceFab = actionCreator(
  '[mainApp/fab/referenceFab] ACTIVATE_REFERENCE_FAB'
);
